var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/navigation/help") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/navigation/help",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,6 C30.836556,6 38,13.163444 38,22 C38,30.836556 30.836556,38 22,38 C13.163444,38 6,30.836556 6,22 C6,13.163444 13.163444,6 22,6 Z M22,8 C14.2680135,8 8,14.2680135 8,22 C8,29.7319865 14.2680135,36 22,36 C29.7319865,36 36,29.7319865 36,22 C36,14.2680135 29.7319865,8 22,8 Z M22.18,26.6 L22.18,29 L19.78,29 L19.78,26.6 L22.18,26.6 Z M21.3,14.28 C23.66,14.28 26.06,15.34 26.06,18.02 C26.06,18.4 26.02,19.18 25.5,19.94 C24.98,20.6853333 24.7454222,20.9349333 24.5489007,21.1184356 L24.46,21.2 L23.32,22.22 C22.26,23.18 22.12,23.48 22.12,24.14 L22.12,24.14 L22.12,25.76 L19.84,25.76 L19.8401807,23.8169531 C19.8428906,23.3985938 19.88625,22.9275 20.58,22.14 L20.58,22.14 L21.46,21.16 C22.26,20.26 22.98,19.26 22.98,18.26 C22.98,17.78 22.82,16.28 20.58,16.28 C19.66,16.28 19.02,16.46 17.92,16.76 L17.92,16.76 L17.92,14.68 C18.68,14.48 19.7,14.28 21.3,14.28 Z",
    id: "common",
    fill: "#3F3F3F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpHome);
export default __webpack_public_path__ + "static/media/help_home.3c3ab345c87cdf3fb3c4e5bc574fb437.svg";
export { ForwardRef as ReactComponent };